<ng-container *transloco="let t; prefix:'customers.customersDetail'">
    @if (customerDetailLoading) {
        <ui-loading-spinner></ui-loading-spinner>
    } @else {
    <div class="page-wrap">
        <div class="headline">
            <div class="title">
                <div class="title-text headline-small-emphasized">{{ customerDetail.ragioneSociale }}</div>

                <button
                    matIconButton
                    type="button"
                    class="notifications-button"
                    [attr.aria-label]="t('notifications.openAriaLabel')"
                    [matBadge]="notificationJson.Count"
                    [matBadgeHidden]="notificationJson.Count === 0"
                    matBadgeColor="warn"
                    matBadgePosition="above after"
                    (click)="onNotificationsButtonClick()"
                    #notificationsOrigin
                >
                    <i class="fa-solid fa-bell"></i>
                </button>
            </div>
            
            <div class="customer-info label-small">{{ t('header.zoneDescription') }}: {{ customerDetail.indirizzo }}</div>
            <div class="customer-info label-small">{{ t('header.vatNumber') }} {{ customerDetail.partitaIva }}</div>
        </div>

        <mat-tab-group
            animationDuration="0ms"
            class="tabs"
            (selectedIndexChange)="onTabIndexChange($event)"
            mat-align-tabs="start"
        >
            <mat-tab [label]="t('tabs.overview')">
                <div class="overview-cards">
                    <span class="historic-title title-medium-emphasized">{{ t('overview.codesAndZones') }}</span>

                    @for (item of customerDetail.oil; track $index) {
                        <mat-card appearance="outlined" class="overview-card-oil">
                            <mat-card-content>
                                <mat-chip disabled class="chip-oil body-medium-emphasized" selected>OIL</mat-chip>
                             
                                <div class="card-info-wrap">
                                    <div class="card-info-block">
                                        <span class="body-small">{{ t('overview.code') }}</span>
                                        <span class="body-medium-emphasized card-value">{{ item.codice }}</span>
                                    </div>

                                    <div class="card-info-block">
                                        <span class="body-small">{{ t('overview.zone') }}</span>
                                        <span class="body-medium-emphasized card-value">{{ item.zona }}</span>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    }

                    @for (item of customerDetail.nonOil; track $index) {
                        <mat-card appearance="outlined" class="overview-card-notOil">
                            <mat-card-content>
                                <mat-chip disabled class="chip-notOil" selected>NON OIL</mat-chip>

                                <div class="card-info-wrap">
                                    <div class="card-info-block">
                                        <span class="body-small">{{ t('overview.code') }}</span>
                                        <span class="body-medium-emphasized card-value">{{ item.codice }}</span>
                                    </div>

                                    <div class="card-info-block">
                                        <span class="body-small">{{ t('overview.zone') }}</span>
                                        <span class="body-medium-emphasized card-value">{{ item.zona }}</span>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    }

                    <span class="historic-title title-medium-emphasized">{{ t('overview.revenueHistory') }}</span>

                    @for (item of receiptstatistics; track $index) {
                        <mat-card appearance="outlined" class="historic-card">
                            <mat-card-content>
                                <div class="historic-card-info">
                                    <span class="body-small historic-card-label">{{ t('overview.revenueValueLabel', { year: item.label }) }}</span>
                                    <span class="body-medium-emphasized">{{ item.value | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}</span>
                                </div>
                            </mat-card-content>
                        </mat-card>

                        <mat-card appearance="outlined" class="historic-card">
                            <mat-card-content>
                                <div class="historic-card-info">
                                    <span class="body-small historic-card-label">{{ t('overview.samePeriodLabel', { year: item.label }) }}</span>
                                    @if (item.perc >= 0) {
                                        <span class="body-medium-emphasized historic-card-trend historic-card-trend-positive">
                                            <i class="fa-solid fa-arrow-trend-up"></i>
                                            <span>+{{ item.perc }}% {{ t('overview.revenue') }}</span>
                                        </span>
                                    } @else {
                                        <span class="body-medium-emphasized historic-card-trend historic-card-trend-negative">
                                            <i class="fa-solid fa-arrow-trend-down"></i>
                                            <span>{{ item.perc }}% {{ t('overview.revenue') }}</span>
                                        </span>
                                    }
                                </div>
                            </mat-card-content>
                        </mat-card>
                    }

                    <span class="data-amn-title title-medium-emphasized">{{ t('overview.administrationData') }}</span>
                    <mat-card appearance="outlined" class="data-amn-card">
                        <mat-card-content>
                            <div class="data-amn-card-info">
                                <span class="body-small data-amn-card-label">{{ t('overview.status') }}</span>
                                <mat-chip
                                    disabled
                                    class="chip-status"
                                    [class.chip-status-active]="customerDetail.attivo === true"
                                    [class.chip-status-inactive]="customerDetail.attivo === false"
                                    [class.chip-status-null]="customerDetail.attivo == null"
                                >
                                    @if (customerDetail.attivo === true) {
                                        {{ t('overview.statusValues.active') }}
                                    } @else if (customerDetail.attivo === false) {
                                        {{ t('overview.statusValues.inactive') }}
                                    } @else {
                                        {{ t('common.empty') }}
                                    }
                                </mat-chip>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <mat-card appearance="outlined" class="data-amn-card">
                        <mat-card-content>
                            <div class="data-amn-card-info">
                                <span class="body-small data-amn-card-label">{{ t('overview.assignedCreditLimit') }}</span>
                                <span class="body-medium-emphasized">
                                    {{ customerDetail.fidoCliente | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                                </span>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <!-- TODO: APPLICARE PROPRIETA' CORRETTE SUI FIDI -->

                    <mat-card appearance="outlined" class="data-amn-card">
                        <mat-card-content>
                            <div class="data-amn-card-info">
                                <span class="body-small data-amn-card-label">{{ t('overview.residualCreditLimit') }}</span>
                                <span class="body-medium-emphasized">
                                    {{ customerDetail.fidoCliente | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                                </span>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <mat-card appearance="outlined" class="data-amn-card">
                        <mat-card-content>
                            <div class="data-amn-card-info">
                                <span class="body-small data-amn-card-label">{{ t('overview.accountingExposure') }}</span>
                                <span class="body-medium-emphasized">
                                    {{ customerDetail.esposizione | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                                </span>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <mat-card appearance="outlined" class="data-amn-card">
                        <mat-card-content>
                            <div class="data-amn-card-info">
                                <span class="body-small data-amn-card-label">{{ t('overview.commercialCommitment') }}</span>
                                <span class="body-medium-emphasized">
                                    {{ customerDetail.impegnoCommerciale | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                                </span>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </mat-tab>
            <mat-tab [label]="t('tabs.registry')">
                <div class="anagrafica-sections">
                    <div class="anagrafica-header">
                        <span class="anagrafica-title title-medium-emphasized">{{ t('anagrafica.title') }}</span>

                        <!--
                        <button
                            matButton
                            type="button"
                            class="anagrafica-edit-button"
                            aria-label="Modifica informazioni anagrafiche"
                        >
                            <span class="anagrafica-edit-button-content">
                                <i class="fa-regular fa-pen"></i>
                                <span>Modifica</span>
                            </span>
                        </button>
                        -->
                    </div>

                    <div class="anagrafica-overview">
                        @for (field of anagraficaFields; track field.key) {
                            <div class="anagrafica-overview-field anagrafica-overview-card">
                                <span class="label-small anagrafica-overview-label">{{ t(field.labelKey) }}</span>
                                <span class="label-small-emphasized anagrafica-overview-value">
                                    @if (field.key === 'clienteDal') {
                                        {{ customerDetail.clienteDal ? (customerDetail.clienteDal | date:'dd/MM/yyyy') : '-' }}
                                    } @else {
                                        {{ getAnagraficaValue(field.key) }}
                                    }
                                </span>
                            </div>

                            @if (!$last) {
                                <hr class="anagrafica-overview-divider" />
                            }
                        }
                    </div>

                    <div class="contacts">
                        <span class="contacts-title title-medium-emphasized">{{ t('contacts.title') }}</span>

                        <button
                            matIconButton
                            type="button"
                            class="contacts-action contacts-action-mobile"
                            [attr.aria-label]="t('contacts.addAriaLabel')"
                            (click)="openAddContactDialog()"
                        >
                            <i class="fa-regular fa-user-plus"></i>
                        </button>

                        <button
                            matButton="filled"
                            type="button"
                            class="contacts-action-filled"
                            [attr.aria-label]="t('contacts.addAriaLabel')"
                            (click)="openAddContactDialog()"
                        >
                            <span class="contacts-action-filled-content">
                                <i class="fa-regular fa-user-plus"></i>
                                <span>{{ t('contacts.add') }}</span>
                            </span>
                        </button>
                    </div>

                    <div class="contacts-list">
                        <!-- TODO: Introdurre eventualmente ciclo for quando dettaglio sarà completo -->
                        @for (contact of customerContacts; track contact.id) {
                        <div class="contact-element contact-element-mobile">
                            <div class="contact-element-content">
                                <span class="body-medium-emphasized">{{ contact.nominativo || '-' }}</span>
                                <span class="body-small">{{ contact.ruolo || '-' }}</span>
                            </div>

                            <div class="contact-element-actions">
                                <button
                                    matIconButton
                                    type="button"
                                    class="contacts-action"
                                    [attr.aria-label]="t('contacts.callAriaLabel', { name: contact.nominativo })"
                                    (click)="openContactPhone(contact)"
                                    [disabled]="!contact.cellulare && !contact.telefono"
                                >
                                    <i class="fa-regular fa-phone"></i>
                                </button>

                                <button
                                    matIconButton
                                    type="button"
                                    class="contacts-action"
                                    [attr.aria-label]="t('contacts.moreActionsAriaLabel', { name: contact.nominativo })"
                                    (click)="setSelectedContact(contact)"
                                    [matMenuTriggerFor]="contactActionsMenu"
                                >
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </button>
                            </div>
                        </div>
                            <div class="contact-card">
                                <div class="contact-card-content">
                                    <div class="contact-card-header">
                                        <div class="contact-card-header-layout">
                                            <div class="contact-card-header-content">
                                                <span class="body-medium-emphasized">{{ contact.nominativo || '-' }}</span>

                                                <span class="contact-card-description">
                                                    @if (contact.principale) {
                                                        <i class="fa-solid fa-circle-check"></i>
                                                    }

                                                    <span class="body-small">{{ contact.ruolo || '-' }}</span>
                                                </span>
                                            </div>

                                            <button
                                                matIconButton
                                                type="button"
                                                class="contact-card-action"
                                                [attr.aria-label]="t('contacts.moreActionsAriaLabel', { name: contact.nominativo })"
                                                (click)="setSelectedContact(contact)"
                                                [matMenuTriggerFor]="contactActionsMenu"
                                            >
                                                <i class="fa-solid fa-ellipsis-vertical"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="contact-card-divider"></div>
                                    <div class="contact-card-details">
                                        <div class="contact-card-detail-item">
                                            <span class="body-medium">{{ t('contacts.phone') }}</span>
                                            <span class="body-medium-emphasized">{{ contact.telefono || '-' }}</span>
                                        </div>

                                        <div class="contact-card-detail-item">
                                            <span class="body-medium">{{ t('contacts.email') }}</span>
                                            <span class="body-medium-emphasized">{{ contact.email || '-' }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            @if (!$last) {
                                <hr class="anagrafica-overview-divider" />
                            }
                        }
                    </div>

                    <mat-menu #contactActionsMenu="matMenu" class="action-menu">
                        <div class="action-wrap">
                            <button class="action-menu-item" mat-menu-item (click)="openSelectedContactEmail()" [disabled]="!selectedContact?.email">
                              <span class="action-menu-content">
                                <i class="fa-regular fa-envelope action-menu-icon"></i>
                                <span class="label-large">{{ t('contacts.email') }}</span>
                              </span>
                            </button>
                        </div>
                        <div class="action-wrap">
                            <button class="action-menu-item" mat-menu-item (click)="selectedContact && openEditContactDialog(selectedContact)">
                              <span class="action-menu-content">
                                <i class="fa-regular fa-pencil action-menu-icon"></i>
                                <span class="label-large">{{ t('common.edit') }}</span>
                              </span>
                            </button>
                        </div>
                        <hr class="action-menu-divider">
                        <div class="action-wrap">
                            <button class="action-menu-item" mat-menu-item (click)="deleteSelectedContact()">
                              <span class="action-menu-content">
                                <i class="fa-regular fa-trash action-menu-icon-delete"></i>
                                <span class="label-large action-menu-label-delete">{{ t('common.delete') }}</span>
                              </span>
                            </button>
                        </div>           
                    </mat-menu>
                </div>
            </mat-tab>
            <mat-tab [label]="t('tabs.deliveryDestinations')">
                <div class="destini-section">
                    @if (!isDesktop) {
                    <div class="address-header">
                        <span class="title-large-emphasized">{{ t('delivery.defaultAddress.title') }}</span>
                        <button
                            matButton
                            type="button"
                            [attr.aria-label]="t('delivery.defaultAddress.changeAriaLabel')"
                            (click)="openDeliveryDestinationsDialog()"
                        >
                            {{ t('common.change') }}
                        </button>
                    </div>

                    <div class="address-card">
                        <div class="address-card-layout">
                            <div class="address-card-content">
                                @for (field of destinoAttivoFields; track field.key) {
                                    <div class="address-card-field">
                                        <span class="body-small">{{ t(field.labelKey) }}</span>
                                        <span class="body-small-emphasized">{{ getDestinoAttivoValue(field.key) }}</span>
                                    </div>
                                }
                            </div>

                            <div class="address-card-action">
                                <button
                                    matIconButton
                                    type="button"
                                    [attr.aria-label]="t('delivery.defaultAddress.infoAriaLabel')"
                                    (click)="openAddressDetailsDialog()"
                                >
                                    <i class="fa-regular fa-circle-info"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    }

                    <span class="title-large-emphasized payment-title">{{ t('delivery.paymentTerms.title') }}</span>

                    <div class="payment-card">
                        <div class="payment-card-content">
                            <div class="payment-card-row">
                                <span class="body-small">{{ t('delivery.paymentTerms.oilCode') }}: <span class="body-small-emphasized">{{ customerDetail.oil[0]?.codice }}</span></span>
                            </div>

                            <div class="payment-card-row">
                                <span class="body-small">{{ t('delivery.paymentTerms.term') }}: <span class="body-small-emphasized">{{ customerDetail.oil[0]?.terminePagamento }}</span></span>
                            </div>

                            <div class="payment-card-row payment-card-row-status">
                                <span class="body-small">{{ t('delivery.paymentTerms.paymentReliability') }}:</span>
                                <!-- TODO: rivedere le chip con oggetto definitivo -->
                                <mat-chip
                                    disabled
                                    class="chip-payment-reliability"
                                    [class.chip-payment-reliability-active]="customerDetail.attivo === true"
                                    [class.chip-payment-reliability-inactive]="customerDetail.attivo === false"
                                    [class.chip-payment-reliability-null]="customerDetail.attivo == null"
                                >
                                    @if (customerDetail.attivo === true) {
                                        {{ t('delivery.paymentTerms.reliabilityValues.onTime') }}
                                    } @else if (customerDetail.attivo === false) {
                                        {{ t('delivery.paymentTerms.reliabilityValues.irregular') }}
                                    } @else {
                                        {{ t('common.empty') }}
                                    }
                                </mat-chip>
                            </div>
                        </div>
                    </div>

                    @if (isDesktop) {
                        <span class="title-large-emphasized delivery-destinations-title">
                            {{ t('delivery.destinations.title') }}
                        </span>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="delivery-destination-search">
                            <input matInput type="text" placeholder="Cerca destino...">
                        </mat-form-field>

                        @for (destination of sortedDeliveryDestinations; track destination.riferimento) {
                            <div class="delivery-destination-card">
                                <div class="delivery-destination-card-content">
                                    <div class="delivery-destination-card-header">
                                        <div class="delivery-destination-card-header-item">
                                            <div class="delivery-destination-card-header-item-content">
                                                <span class="body-small">{{ destination.riferimento || '-' }}</span>
                                                <span class="body-medium-emphasized">
                                                    {{ destination.citta || '-' }}@if (destination.provincia) { ({{ destination.provincia }}) }
                                                </span>
                                                @if (destination.principale) {
                                                    <div class="delivery-destination-card-header-item-default">
                                                        <i class="fa-solid fa-star"></i>
                                                        <span class="body-small">{{ t('delivery.destinations.defaultDestination') }}</span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div class="delivery-destination-card-header-actions">
                                            <button
                                                matButton
                                                type="button"
                                                class="delivery-destination-card-action-edit"
                                                [attr.aria-label]="t('delivery.destinations.editAriaLabel')"
                                                (click)="openEditAddressDetailsDialog(destination)"
                                            >
                                                <span class="delivery-destination-card-action-content">
                                                    <i class="fa-solid fa-pen"></i>
                                                    <span>{{ t('common.edit') }}</span>
                                                </span>
                                            </button>

                                            <button
                                                matButton="outlined"
                                                type="button"
                                                class="delivery-destination-card-action-default"
                                                [attr.aria-label]="t('delivery.destinations.setDefaultAriaLabel')"
                                                [disabled]="destination.principale === true"
                                                (click)="setDefaultDeliveryDestination(destination)"
                                            >
                                                <span class="delivery-destination-card-action-content">
                                                    <i class="fa-regular fa-star"></i>
                                                    <span>{{ t('delivery.destinations.setAsDefault') }}</span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="delivery-destination-card-divider"></div>
                                    <div class="delivery-destination-card-details">
                                        <div class="delivery-destination-card-generalities">
                                            <div class="delivery-destination-card-generalities-content">
                                                @for (field of deliveryDestinationGeneralitiesFields; track field.key) {
                                                    <div class="delivery-destination-card-generalities-field">
                                                        <span class="body-small">{{ t(field.labelKey) }}</span>
                                                        <span class="body-medium-emphasized">{{ getDeliveryDestinationGeneralityValue(destination, field.key) }}</span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div class="delivery-destination-card-notes">
                                            <span class="body-medium-emphasized">{{ t('tabs.notes') }}</span>
                                            <div class="delivery-destination-card-notes-content">
                                                @for (field of deliveryDestinationNotesFields; track field.key) {
                                                    <div class="delivery-destination-card-notes-field">
                                                        <span class="body-small">{{ t(field.labelKey) }}</span>
                                                        @if (field.key === 'sponda') {
                                                            <span class="body-medium-emphasized">
                                                                {{ destination.nota.sponda === true ? t('common.yes') : t('common.no') }}
                                                            </span>
                                                        } @else {
                                                            <span class="body-medium-emphasized">{{ destination.nota[field.key] || '-' }}</span>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div class="delivery-destination-card-divider"></div>
                                    <div class="delivery-destination-card-footer">
                                        <mat-checkbox
                                            class="delivery-destination-card-footer-checkbox"
                                            [checked]="destination.nota.inBolla"
                                            tabindex="-1"
                                        >
                                            {{ t('delivery.destinations.addToDeliveryNote') }}
                                        </mat-checkbox>
                                    </div>
                                </div>
                            </div>
                        }
                    }
                </div>
            </mat-tab>
            <mat-tab [label]="t('tabs.notes')">
                <div class="notes-section">
                    <div class="address-header">
                        <span class="title-large-emphasized">{{ t('tabs.notes') }}</span>
                        @if (!notesSelectionMode) {
                            <button
                                matButton
                                type="button"
                                [attr.aria-label]="t('notes.addAriaLabel')"
                                (click)="openAddNoteDialog()"
                            >
                                {{ t('notes.add') }}
                            </button>
                        }
                    </div>

                    @if (notesSelectionMode) {
                        <div class="notes-selection-toolbar">
                            <button
                                matButton
                                type="button"
                                class="notes-selection-clear"
                                [attr.aria-label]="t('notes.clearSelectionAriaLabel')"
                                (click)="exitNotesSelectionMode()"
                            >
                                <span class="notes-selection-clear-content">
                                    <i class="fa-regular fa-xmark"></i>
                                    <span>{{ t('notes.selectedCount', { count: selectedNoteIds.size }) }}</span>
                                </span>
                            </button>

                            <button
                                matButton="outlined"
                                type="button"
                                [attr.aria-label]="t('notes.deleteSelectedAriaLabel')"
                                (click)="deleteSelectedNotes()"
                            >
                                {{ t('common.delete') }}
                            </button>
                        </div>
                    }

                    <div class="notes-list">
                        @for (item of customerNotes; track item.id) {
                            <div
                                class="note-card"
                                [class.note-card-selection-mode]="notesSelectionMode"
                                role="button"
                                tabindex="0"
                                [attr.aria-label]="t('notes.openDetailAriaLabel')"
                                (click)="onNoteCardClick(item)"
                                (keydown)="onNoteCardKeydown(item, $event)"
                                (mousedown)="startNoteLongPress(item)"
                                (mouseup)="clearNoteLongPress()"
                                (mouseleave)="clearNoteLongPress()"
                                (touchstart)="startNoteLongPress(item)"
                                (touchend)="clearNoteLongPress()"
                                (touchcancel)="clearNoteLongPress()"
                            >
                                @if (notesSelectionMode) {
                                    <div class="note-card-selection">
                                        <mat-checkbox
                                            [checked]="isNoteSelected(item.id)"
                                            [attr.aria-label]="t('notes.selectAriaLabel')"
                                            (click)="$event.stopPropagation()"
                                            (change)="toggleNoteSelection(item.id)"
                                        ></mat-checkbox>
                                    </div>
                                }

                                <div class="note-card-content">
                                    <span class="body-small note-card-date">{{ item.data | date:'dd/MM/yyyy HH:mm' }}</span>
                                    <span class="body-medium-emphasized note-card-title">{{ item.titolo }}</span>
                                    <span class="body-small note-card-text">{{ item.testo }}</span>
                                </div>

                                <button
                                    matIconButton
                                    type="button"
                                    class="note-card-action"
                                    [attr.aria-label]="t('notes.editAriaLabel')"
                                    (click)="openEditNoteDialog(item); $event.stopPropagation()"
                                >
                                    <i class="fa-regular fa-pen"></i>
                                </button>
                            </div>
                        }
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    }

    <ng-template #notificationsPanel>
        <div class="notifications-panel" role="dialog" [attr.aria-label]="t('notifications.panelAriaLabel')">
            <div class="notifications-panel-header">
                <span class="title-large-emphasized">{{ t('notifications.title') }}</span>

                <button
                    matIconButton
                    type="button"
                    [attr.aria-label]="t('notifications.closeAriaLabel')"
                    (click)="closeNotificationsPanel()"
                >
                    <i class="fa-regular fa-xmark"></i>
                </button>
            </div>

            <div class="notifications-panel-content">
                <div class="notifications-list">
                    @for (item of notificationJson.Notifications; track item.Id) {
                        <div class="notification-card" [class]="getNotificationCardClass(item.Severity)">
                            <div class="notification-card-header">
                                <div class="notification-card-header-container">
                                    <div class="notification-card-header-icon-container">
                                        <div class="notification-card-icon">
                                            <i [class]="getNotificationIconClass(item.Severity) + ' ' + getNotificationIconColorClass(item.Severity)"></i>
                                        </div>
                                    </div>

                                    <div class="notification-card-header-content">
                                        <span class="body-medium-emphasized notification-card-title" [class]="getNotificationIconColorClass(item.Severity)">{{ item.Title }}</span>
                                        <span class="body-medium notification-card-description">{{ item.Description || '-' }}</span>
                                    </div>
                                </div>

                                <div class="notification-card-header-close">
                                    <button matIconButton type="button" (click)="$event.stopPropagation()">
                                        <i class="fa-regular fa-xmark"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="notification-card-footer">
                                @if (item.ToAction) {
                                    <button matButton type="button" class="notification-card-action">
                                        <span class="notification-card-action-content">
                                            <i class="fa-regular fa-up-right-from-square"></i>
                                            <span>{{ getNotificationActionLabel(item) }}</span>
                                        </span>
                                    </button>
                                }
                            </div>
                        </div>
                    }

                    @if (!notificationJson.Notifications?.length) {
                        <div class="notifications-empty-state">
                            <span class="body-large-emphasized">{{ t('notifications.emptyState.title') }}</span>
                            <span class="body-medium">{{ t('notifications.emptyState.description') }}</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    </ng-template>

</ng-container>
